import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { postAPIHandler, useBanners } from "../../Api/api";
import { Helmet } from "react-helmet";
import AdBanner from "../../Components/AdBanner";

const News_Details = () => {
  const { newsId } = useParams();
  const [newsDetails, setNewsDetails] = useState([]);
  // console.log("newsDetails - ", newsDetails);

    const { horizontal} = useBanners();


  const getNewsDetails = async (value) => {
    const formData = new FormData();
    formData.append("news_id", value);

    const response = await postAPIHandler("seriesNewsDetail", formData);
    setNewsDetails(response.data);
  };

  useEffect(() => {
    getNewsDetails(newsId);
  }, [newsId]);
  return (
    <>
      <Helmet>
        <title>
          Latest Sports News & Updates | Detailed Insights at cricket betting
          tips
        </title>
        <meta
          name="description"
          content="Stay informed with cricket betting tips for in-depth details and breaking news on sports. Get the latest updates, analysis, and reports on all your favorite games."
        />
      </Helmet>
      {newsDetails.length !== 0 && (
        <div className="bg-[#000]"> 
        <div className="xl:w-[90%] w-[96%] mx-auto py-10 ">
          <div className="mb-4">
            <img
              src={newsDetails.image}
              alt=""
              className="xl:h-[600px] md:h-[400px] object-cover object-top"
            />
          </div>
          <p className="mb-2 text-[18px] font-[400] text-[#ffffffaf]">
            {newsDetails.pub_date}
          </p>
          <h1>{newsDetails.title}</h1>

                {/* ==========Advertisement============== */}
          <div className="lg:mb-5 mb-[10px] mt-4"><AdBanner data={horizontal} type="horizontal" /> </div>
          <div
            className="mt-md-5 mt-4 text-justify font-[18px]"
            dangerouslySetInnerHTML={{
              __html: newsDetails.content,
            }}
          />
        </div>
        </div>
      )}
    </>
  );
};

export default News_Details;
